import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';


const Navbar = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light container-nav">
            <div className="container-fluid">
            <Link className="navbar-brand" to="/">
                    <h2 className="text-warning fst-italic"><strong>M</strong></h2>
                </Link>
                <div className="position-absolute pb-5 mt-5 top-0 start-0 translate-middle">
                <button className="navbar-toggler mt-5 mb-5 bg-warning ms-5" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                </div>
                
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav fs-5  ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link ms-5 text-warning fw-bold" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-5 text-warning fw-bold" to="/about">About Me</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-5 text-warning fw-bold" to="/portfolio">Portfolio</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-5 text-warning fw-bold" to="/blog">Blog</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-5 text-warning fw-bold" to="/contact">Contact</Link>
                        </li>
                        
                    </ul>

                </div>
            </div>
        </nav>

    );
};

export default Navbar;